
// ROUTES
require('modules/grand-prix/routes/grand-prix');

// CONTROLLERS
require('modules/grand-prix/controllers/grand-prix');
require('modules/grand-prix/controllers/list');
require('modules/grand-prix/controllers/list-zm');
require('modules/grand-prix/controllers/view-zm');

/*require('modules/event/controllers/detail');
require('modules/event/controllers/create');
require('modules/event/controllers/edit');
require('modules/event/controllers/site');
require('modules/event/controllers/send');
*/

// SERVICES
require('modules/grand-prix/services/grand-prix');
require('modules/grand-prix/services/list');
require('modules/grand-prix/services/send');
require('modules/grand-prix/services/edit');
/*require('modules/event/services/create');
require('modules/event/services/delete');
require('modules/event/services/site');

*/

angular.module('unica_grand_prix', [

	// ROUTES
	'unica_grand_prix.grand_prix_routes',

	// CONTROLLERS
	'unica_grand_prix.grand_prix_controllers',

	// SERVICES
	'unica_grand_prix.grand_prix_services'

]);